import { render, staticRenderFns } from "./RetailerDetail.vue?vue&type=template&id=47c2da1e&scoped=true"
import script from "./RetailerDetail.vue?vue&type=script&lang=js"
export * from "./RetailerDetail.vue?vue&type=script&lang=js"
import style0 from "./RetailerDetail.vue?vue&type=style&index=0&id=47c2da1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2da1e",
  null
  
)

export default component.exports